module.exports = __webpack_public_path__ + "static/img/2.2db3edb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/gift/2.png
// module id = DLMn
// module chunks = 2